// extracted by mini-css-extract-plugin
module.exports = {"radioLabel":"Checkbox_radioLabel__1Lhr2","radioInput":"Checkbox_radioInput__1GPyt","radio":"Checkbox_radio__35dZ5","text":"Checkbox_text__11gTP"};